import React from 'react';
import cx from 'classnames';

import {
  TableCell,
} from 'spindl-shared-components';

import styles from './CSVRow.module.scss';
import usePresenter from './CSVRow.presenter';
import { CSVRowCombinedProps } from './types';


const CSVRow: React.FC<CSVRowCombinedProps> = (props) => {
  const {
    styleType,
    htmlTag,
    className,
    checkbox,
    name,
    email,
    role,
  } = usePresenter(props);

  const variantName = `${htmlTag || ''}${styleType}`;
  const currentStyle = styles[`cSVRow${variantName}`];


  let componentView;

  switch (variantName) {
    case 'Default':
    case 'Header': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <TableCell
            {...checkbox}/>
          <TableCell
            {...name}/>
          <TableCell
            {...email}/>
          <TableCell
            {...role}/>
        </div>
      );
      break;
    }
    case 'divDefault':
    case 'divHeader': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <TableCell
            {...checkbox}/>
          <TableCell
            {...name}/>
          <TableCell
            {...email}/>
          <TableCell
            {...role}/>
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default CSVRow;
